import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { Button } from 'dibs-elements/exports/Button';

type Props = {
    onClick: () => void;
};

export const SbRespInteriorsViewButton: FC<Props> = ({ onClick }) => {
    return (
        <Button dataTn="view-interiors" onClick={onClick} size="small">
            <FormattedMessage
                defaultMessage="View this interior"
                id="abf.SbRespInteriorsViewButton.buttonText"
            />
        </Button>
    );
};
